import { SET_DOMAINS_LIST } from '../../constants/domainsList';

const initialState = {
	domainsList: []
};

const domainsListReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_DOMAINS_LIST:
			return {
				domainsList: action.payload
			};
		default:
			return state;
	}
};

export default domainsListReducer;
